const DefaultPriceBlockFormState = {
    payload: {
        price: '',
    },
    errors: [],
    errorsPresent: false,
    submitted: false,
    dispatchAPI: false,
    mode: ``,
    message: ``,
    site_id: ``,
    organization_id: ``,
};

export const PriceBlockFormState = {data: DefaultPriceBlockFormState};